<style src="./LogHistory.scss" lang="scss"></style>
<template>
  <section class="LogHistory">
    <div class="ibox">
      <div class="ibox-content">

        <h2 class="title is-4" title="Historico detalhado da compra de crédito para a carteira">Histórico de Ações</h2>
        
        
        <div class="table-responsive content">
          <Spinner v-if="isLoading" />
          <div class="text-center" v-if="!isLoading && list.length === 0">
            <h3>Nenhum registro encontrado!</h3>
            <div class="error-desc">
              Não foram encontrados nenhuma ação deste cliente.
            </div>
          </div>

          <table class="table table-striped table-hover" v-if="!isLoading && list.length > 0">
            <thead>
              <tr>
                <th>Data</th>
                <th>Hora</th>
                <th>Ação</th>
                <th>Descrição</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in list" :key="index">
                  <td class="date">{{ item.createdAt | formatDate }}</td>
                  <td class="hours">{{ item.createdAt | formatTime}}</td>
                  <td class="client-status action"><span class="label" :style="{ backgroundColor: item.label.color }">{{ item.label.label }}</span></td>
                  <td class="description"><small>{{ item.description }}</small></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="text-right">
          <div class="btn-group">
            <button class="btn btn-white" type="button" :disabled="previousButtonDisabled" @click="previousPage">
              <i class="fa fa-chevron-left"></i>
            </button>
            <button class="btn btn-white" type="button" :disabled="nextButtonDisabled" @click="nextPage">
              <i class="fa fa-chevron-right"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import Spinner from '@/components/Spinner';
export default {
  components: {
    // Statement,
    Spinner,
  },
  data() {
    return {
      isLoading: false,
      list: [],
      countTotal: 0,
      pageSkip: 0,
      pageLimit: 6,
      isModalVisible: false,
    }
  },
  filters: {
    formatDate(value) {
      if (!value) return ''
      const date = new Intl.DateTimeFormat('pt-BR', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
      }).format(new Date(value));

      return date;
    },
    formatTime(value) {
      if (!value) return ''
      const time = new Intl.DateTimeFormat('pt-BR', {
        hour: '2-digit',
        minute: '2-digit',
      }).format(new Date(value));

      return time;
    },
    paidStatus(value) {
      if (value) {
        return 'Pago';
      }
      return 'Pendente';
    }
  },
  mounted() {
    this.loadInfo();
  },
  computed: {
    previousButtonDisabled() {
      return this.pageSkip === 0;
    },
    nextButtonDisabled() {
      return this.pageSkip + this.pageLimit >= this.countTotal;
    }
  },
  methods: {
    async loadInfo() {
      try {
        this.isLoading = true;
        
        const payload = {
          pageSkip: this.pageSkip,
          pageLimit: this.pageLimit,
          user: this.$route.params.userToken,
        };
        const logHistory = await this.$store.dispatch(
          'CONSUMER/LogHistory',
          payload,
        );

        this.list = logHistory.history;
        this.countTotal = logHistory.countTotal;
      } catch(error) {
        console.error('Error loading consumer info:', error);
      } finally {
        this.isLoading = false;
      }
    },
    nextPage() {
      this.pageSkip += this.pageLimit;
      this.loadInfo();
    },
    previousPage() {
      this.pageSkip -= this.pageLimit;
      this.loadInfo();
    },
    showDetails(item) {
      console.log('item', item)
      this.details.dateCreated = item.dateCreated;
      this.details.datePayment = item.paymentDate;
      this.details.transactionId = item.transactionId;
      this.details.amountPaid = item.amountPaid;
      this.details.method = item.method;
      this.details.paid = item.paid;
      this.details.status = item.status;

      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    methodStyle(method) {
      switch (method) {
        case 'PIX':
          return 'label-success';
        case 'Cartão':
          return 'label-warning';
        case 'Bônus':
          return 'label-info';
        default:
          return '';
      }
    },
    paidStyle(paid) {
      if (paid) {
        return 'label-primary';
      }
      return 'label-danger';
    } 
  }
};
</script>
